import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations, LANGUAGES, detectBrowserLang, tr } from "../i18n";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try {
      const stored = localStorage.getItem("rf_ui_lang");
      if (stored && translations[stored]) return stored;
    } catch (e) {}
    return detectBrowserLang();
  });

  useEffect(() => {
    try { localStorage.setItem("rf_ui_lang", lang); } catch (e) {}
    if (typeof document !== "undefined") document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((l) => {
    if (translations[l]) setLangState(l);
  }, []);

  const t = useCallback((key, vars) => tr(lang, key, vars), [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
}
